import { Button } from '@mui/material';
import styles from './Buttons.module.css';

import closeIcon from '../../../../Assets/icons/toastIcon/closeIcon.svg';

function CloseButton({ onClick, size = 12 }) {
  return (
    <Button
      type="button"
      variant="outlined"
      size="small"
      className={styles.closeButton}
      onClick={onClick}
    >
      <img src={closeIcon} alt="close" width={size} height={size} />
    </Button>
  );
}

export default CloseButton;
